var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"afbs-timer"}},[_c('Timer',{attrs:{"endDate":new Date(_vm.endDate)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }